import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { FilesService } from '../../services/files.service';
import { DialogService } from '../../services/dialog.service';
import { File } from '../../Interfaces/File';

@Component({
  selector: 'app-files-view',
  templateUrl: './files-view.component.html',
  styleUrls: ['./files-view.component.scss']
})
export class FilesViewComponent implements OnInit {
      //Nombre de las columnas de la tabla de archivos
      public displayedColumns = ['#', 'nameFile', 'action'];
      //Datasource para la tabla de archivos
      public dataSource: MatTableDataSource<any>;
      //Arreglo donde se guardaran los archivos que se mandan para visualizar o cuando se suban nuevos
      public files: any;
      //Booleano para saber si solomente es lectura de archivos, o puede modificar las propiedades (Agregar y eliminar)
      public onlyRead: boolean = true;
      //Titulo del modal, por defecto son archivos
      public title: string = 'Archivos';

      public index: number;
      //Parametros para mandar al backenm
      public dataToSend: any;
      //Parametros para el componente de  [UploadFilesComponent] (Son configuraciones del componente)
      public uploadData: any;
      //Array de los archivos que se subieron
      public createdFiles: any = []

      @ViewChild(MatSort) sort: MatSort;

      constructor(
        @Optional()
        @Inject(MAT_DIALOG_DATA) public data: any,
        //Servicio de files
        private _filesService: FilesService,
        //Service del toast
        private toastr: ToastrService,
        // Servicio del los dialogs
        private dialogService: DialogService,

        // Es una referencia al diálogo para subir archivos
        private dialogRef: MatDialogRef<FilesViewComponent>



      ) {
        //Validamos si existen las propiedades de title, onlyRead,uploadData e index
        //*Esto se agrego para no causar conflictos entre los otros modulos donde se use el archivo
        if (data.title !== null && data.title !== undefined) {
          this.title = data.title
        }
        if (data.onlyRead !== null && data.onlyRead !== undefined) {
          this.onlyRead = data.onlyRead
        }
        if (data.uploadData !== null && data.uploadData !== undefined) {
          this.uploadData = data.uploadData
        }
        if (data.index !== null && data.index !== undefined) {
          this.index = data.index
        }
        //Parseamos los files que recibe el componente
        this.files = JSON.parse(data.files)

        //Filtramos el array para no tener files repetidos
        this.files = this.files.filter((file, index) => {
          return this.files.findIndex((f) => f.nameFile === file.nameFile) === index;
        });
        //Asignamos los archivos al datasource
        this.dataSource = new MatTableDataSource<any>(this.files)
      }

      ngOnInit(): void {
      }
      //Cargamos el sort
      ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
      }
      /**
      * Abre un archivo en una nueva pestaña del navegador según el módulo actual.
      * @param file Archivo que debe abrir
      */
      openFile(file) {
            // Abre el archivo  relacionado a la Orden de Trabajo
            this._filesService.openFileFromStorage(file.path, file.nameFile).subscribe(
              (res) => {
                // Obtener la URL del archivo
                const fileURL = URL.createObjectURL(res);
                // Abrir el archivo en una nueva pestaña del navegador
                window.open(fileURL, '_blank');
              },
              (error) => {
                this.toastr.error('Ha ocurrido un error al abrir o generar el archivo');
              }
            );
      }

      /**
       * Aplica un filtro de búsqueda en la tabla de archivos.
       * @param event El evento de entrada que contiene el valor del filtro.
       */
      applyFilter(event: Event) {
        // Obtiene el valor del filtro del evento de entrada
        const filterValue = (event.target as HTMLInputElement).value;
        // Aplicar el filtro al origen de datos de la tabla
        this.dataSource.filter = filterValue.trim().toLowerCase();
        // Reiniciar la paginación a la primera página después de aplicar el filtro
      }


      /**
     * Elimina un archivo del storage
     * Abre un modal de confirmación y realiza diferentes acciones (Eliminar, no eliminar o cancelar )
     * Actualiza el dataSource la tabla de archivos
     * @param fileToDelete - Archivo que eliminara

     */
      async deleteFile(fileToDelete: File) {
        // Crea el pathFile donde se encuentra el archivo
        let pathFile = `${fileToDelete.path}/${fileToDelete.nameFile}`
        //Abre el modal de confirmación
        const isConfirm = await this.dialogService.openConfirmDialog({
          message: `¿Estás seguro que quieres eliminar el archivo ${fileToDelete.nameFile}?`,
          name: 'Verifica los datos'
        });
        if (!isConfirm) {
          this.toastr.warning('Cancelada');
          return;
        }
        //Llama al servicio para eliminar el archivo
        this._filesService.removeFileFromStorage(pathFile).subscribe(response => {
          //Mostramos toast con las respuesta
          if (response.success == true) {
            this.toastr.success(response.message)
            //Filtramos los files que se eliminaron
            fileToDelete.deleted = 1;
            const deletedIndex = this.files.findIndex(file => file.nameFile === fileToDelete.nameFile);
            let files = this.files.filter(file => file.nameFile !== fileToDelete.nameFile);
            this.files[deletedIndex] = fileToDelete;
            this.createdFiles = this.createdFiles.filter(file => file.nameFile !== fileToDelete.nameFile);
            this.dataSource = new MatTableDataSource<any>(files);
            this.dataSource.sort = this.sort;
          } else {
            this.toastr.error(response.message)
          }
        },
          (error) => {
            this.toastr.error('Ha ocurrido un error al intentar eliminar el archivo');
          });


      }
      /**
     * Abre el modal de [UploadFilesComponent]
     * Sube los archivos
     * Actualiza el dataSource la tabla de archivos
     */
      async uploadFiles() {
        try {
          //Resultado del modal de  [UploadFilesComponent]
          const result = await this.dialogService.openUploadDialog(this.uploadData)
          //Si se subieron los archivos, modificamos arrays y filtramos
          if (result.success == true) {
            //Al array de createdFiles le hacemos un push con los archivos nuevos que se subieron
            this.createdFiles.push(...result.nameFiles)
            //AL array de files le hacemos un push con los createdFiles, esto para tener tanto los archivos que ya existen como los nuevos que se agregaron
            this.files.push(...this.createdFiles)
            //Filtramos el array para no tener files repetidos
            this.files = this.files.filter((file, index) => {
              // Retorns solo los archivos cuyo índice es el primero encontrado con ese nombre de archivo
              return this.files.findIndex((f) => f.nameFile === file.nameFile) === index;
            });
            //Actualizamos el data source de la tablla con los files
            this.dataSource = new MatTableDataSource<any>(this.files);
          }

        } catch (error) {

          this.toastr.error('Ha ocurrido un error', error)
        }
      }
      /**
      * Cierra el diálogo y devuelve el array de archivos filtrado.
      */
      closeDialog(): void {
        // Cierra el diálogo y devolver el array de archivos filtrado
        this.dialogRef.close(this.files);

      }


}
